
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/valuation",
      function () {
        return require("private-next-pages/[lang]/valuation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/valuation"])
      });
    }
  